import {
  memberReportRoute,
  offerReportRoute,
  offerCatalogRoute,
  eventsRoute,
  dashboardRoute,
  usersRoute,
  rolesRoute,
  loyalMembersRoute,
  memberCardsRoute,
  projectsRoute,
  retailorVendorRoute,
  advertisingRoute,
  pushNotificationRoute,
  userGroupsRoute,
  membershipTiersRoute,
  cardPrintJobsRoute,
  moderationRoute,
  clientRoute,
  moderationHistoryRoute,
  cmsRoute,
} from "../../../routes/reactRoutes";

export const routeKeys = {
  dashboard: [dashboardRoute],
  reporting: [offerReportRoute, memberReportRoute],
  memberReport: [memberReportRoute],
  offerReport: [offerReportRoute],
  management: [usersRoute, rolesRoute],
  userPermission: [usersRoute],
  rolePermission: [rolesRoute],
  moderation: [moderationRoute, moderationHistoryRoute],
  moderations: [moderationRoute],
  moderationHistory: [moderationHistoryRoute],
  loyaltyMembers: [
    loyalMembersRoute,
    memberCardsRoute,
    membershipTiersRoute,
    cardPrintJobsRoute,
  ],
  memberDetails: [loyalMembersRoute],
  memberCards: [memberCardsRoute],
  cardPrinting: [cardPrintJobsRoute],
  membershipTiers: [membershipTiersRoute],
  projects: [projectsRoute],
  userGroups: [userGroupsRoute],
  retailerVendor: [retailorVendorRoute],
  offers: [offerCatalogRoute],
  pushNotification: [pushNotificationRoute],
  events: [eventsRoute],
  cms: [
    cmsRoute,
  ],
  advertising: [advertisingRoute],
  clients: [clientRoute],
};
